import { useCallback } from "react"
import { batch } from "@preact/signals-react"
import { scrollToComponent, postSubmit } from "@ui-seeker/utils"
import { useAppToast } from "@ui-seeker/app"

import { WEBBACK_V2_API } from "@constants"
import { commonFiltersValue } from "@signals"
import { adminNewListedDetails, adminNewListedDetailsData, adminNewListedSkuMappingData } from "../@signals"


export default function useAdminNewListedList(rowData={}, date=null, siteID=null, productID=null, skuID=null) {
	const { showToast } = useAppToast()

	// La sub-tabla de SKU Mapping no trae `detail`, así que sus filas no están en el índice: sin el
	// `?.` el drawer revienta al abrirlo desde ahí. La fila ya lleva lo que el panel enseña.
	const handleClickDetails = useCallback(() => batch(() => {
		adminNewListedDetails.value = {
			...adminNewListedDetailsData.value?.[date]?.[siteID]?.[productID]?.[0],
			...rowData
		}
	}), [JSON.stringify(rowData)])

	// ⚠️ Ruta propia, no la de Admin Review. Su fila no es esta —le faltan `repeatedSku`,
	// `IAOptionsNameList`, `firstDate` y una docena más— y esta tabla las pinta. Y va sin rango de
	// fechas: la pregunta es qué más cuelga de este SKU, no qué colgaba en el periodo buscado.
	const handleClickSkuMapping = useCallback(() =>  {
		showToast.promise(postSubmit(`${WEBBACK_V2_API}/admin/new-listed/sku-mapping`, {...commonFiltersValue.value, retailer: [], sku:[rowData.skuID]}).then(({ table }) => {
			adminNewListedSkuMappingData.value = table
		}).catch(() => {showToast.error()})
		.finally(() => scrollToComponent('new-listed-sku-mapping-table')))
	}, [JSON.stringify(rowData)])

	const handleCloseSkuMappingTable = useCallback(() => batch(() => {
		adminNewListedSkuMappingData.value = []
	}), [])

	return {
		isOpenDrawer: adminNewListedDetails.value.id === rowData.id,
		handleClickDetails, handleCloseSkuMappingTable, handleClickSkuMapping
	}
}